import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  SearchBoxProps,
  SearchBoxDefinition,
  SearchBoxCSSVars,
} from '@wix/thunderbolt-components';
import { ISearchBoxMapperProps } from '../SearchBox.types';

export const props = withCompInfo<
  ISearchBoxMapperProps,
  SearchBoxDefinition,
  SearchBoxProps
>()(['direction'], ({ direction }, carmiProps) => {
  return {
    ...carmiProps,
    direction,
  };
});

export const css = withCompInfo<
  SearchBoxCSSVars,
  SearchBoxDefinition,
  SearchBoxCSSVars
>()([], (_deps, carmiCss) => {
  return carmiCss;
});

export default createComponentMapperModel({ props, css });
